import {
    DisplayTag,
    DisplayTagAppearance,
} from '@volkswagen-onehub/components-core'
import styled from 'styled-components'
import React from 'react'

const RecommendedTag = styled(DisplayTag)<{
    $backgroundColor?: string
    $contentColor?: string
}>`
    white-space: normal;
    height: fit-content;
    ${({$backgroundColor}) =>
        $backgroundColor ? `background-color: ${$backgroundColor};` : ''}
    ${({$contentColor}) => ($contentColor ? `color: ${$contentColor};` : '')}

    p {
        margin: 0;
    }
`

interface EyeCatcherInterface {
    text: string
    appearance?: DisplayTagAppearance
    small?: boolean
    backgroundColor?: string
    contentColor?: string
}

export default function EyeCatcher(
    props: EyeCatcherInterface
): React.JSX.Element {
    return props.text ? (
        <RecommendedTag
            appearance={props.appearance ?? 'technical'}
            $backgroundColor={props.backgroundColor}
            $contentColor={props.contentColor}
            text={
                <span
                    dangerouslySetInnerHTML={{
                        __html: props.text,
                    }}
                />
            }
        />
    ) : (
        <div />
    )
}
